import React, { useEffect, useState } from "react";
import _ from "lodash";
import { useSelector } from "react-redux";
import { getProgressReportStatus } from "../../../core/service/progressReport.service";

import { styled } from "@mui/material/styles";
import { Card, Stack, Stepper, Step, StepLabel, Box } from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import PendingActionsIcon from "@mui/icons-material/PendingActions";

import StepConnector, {
  stepConnectorClasses
} from "@mui/material/StepConnector";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22
  },
  // [`&.${stepConnectorClasses.active}`]: {
  //   [`& .${stepConnectorClasses.line}`]: {
  //     backgroundImage: "linear-gradient(#eaeaf0,#eaeaf0)"
  //   }
  // },
  // [`&.${stepConnectorClasses.completed}`]: {
  //   [`& .${stepConnectorClasses.line}`]: {
  //     backgroundImage: "linear-gradient(#1CD1A1,#1CD1A1)"
  //   }
  // },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1
  }
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => {
  const { choose } = ownerState;

  return {
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
    zIndex: 1,
    color: "#fff",
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
    ...(choose?.type?.type.render.displayName === "CheckIcon"
      ? { backgroundImage: "linear-gradient(#1CD1A1,#1CD1A1)" }
      : choose?.type?.type.render.displayName === "CloseIcon" && {
          backgroundImage: "linear-gradient(#FF0000,#FF0000)"
        })
  };
});

const formatSemester = (statusProgressReport = []) => {
  const res = {
    semester1: [],
    semester2: [],
    semester3: [],
    semester4: [],
    semester5: [],
    semester6: [],
    semester_extension: []
  };

  for (const key in res) {
    res[key] = statusProgressReport
      .filter((e) => e.semester === key)
      .map((e) => ({
        semester:
          (e.mentor_approve === 1 && e.admin_approve === 3) ||
          e.admin_approve === 1
            ? 1
            : (e.mentor_approve === 2 && e.admin_approve === 3) ||
              e.admin_approve === 2
            ? 2
            : 0
      }));
  }

  return res;
};

const getIcon = (semester = []) => {
  const pass = semester?.filter((e) => e.semester === 1).length;
  const notPass = semester?.filter((e) => e.semester === 2).length;
  const pending = semester?.filter((e) => e.semester === 0).length;

  switch (true) {
    case pending !== 0:
      return <PendingActionsIcon />;
    case pass !== 0 && pending === 0:
      return <CheckIcon />;
    case notPass !== 0 && pending === 0:
      return <CloseIcon />;
    default:
      return null;
  }
};

const ROLE_PHD_3Y = "phd_3y";
const ROLE_PHD_5Y = "phd_5y";

export default function StepperPhd() {
  const { role, user: currentUser } = useSelector((state) => state.authReducer);
  const { id } = currentUser;
  const { user: anotherUser, isClickAnotherProfile } = useSelector(
    (state) => state.userProfileReducer
  );
  const [statusProgressReport, setStatusProgressReport] = useState([]);

  const getStatusProgressReport = async (id) => {
    const data = await getProgressReportStatus(id);
    setStatusProgressReport(data?.entities);
  };
  const getStatusProgressReportByUser = async (id) => {
    const data = await getProgressReportStatus(id);
    setStatusProgressReport(data?.entities);
  };

  useEffect(() => {
    if (isClickAnotherProfile) {
      if (anotherUser) getStatusProgressReportByUser(anotherUser?.id);
    } else getStatusProgressReport(id);
  }, []);

  const steps = [
    "Semester 1",
    "Semester 2",
    "Semester 3",
    "Semester 4",
    "Semester 5",
    "Semester 6",
    "Paper Accepted"
  ];

  const steps5y = [
    "Semester 1",
    "Semester 2",
    "Semester 3",
    "Semester 4",
    "Semester 5",
    "Semester 6",
    "Semester 7",
    "Semester 8",
    "Semester 9",
    "Semester 10",
    "Paper Accepted"
  ];

  const steps_extension = [
    "Semester 1",
    "Semester 2",
    "Semester 3",
    "Semester 4",
    "Semester 5",
    "Semester 6",
    "Paper Accepted",
    "Extension of research",
    "Paper Accepted"
  ];

  const steps_extension5y = [
    "Semester 1",
    "Semester 2",
    "Semester 3",
    "Semester 4",
    "Semester 5",
    "Semester 6",
    "Semester 7",
    "Semester 8",
    "Semester 9",
    "Semester 10",
    "Paper Accepted",
    "Extension of research",
    "Paper Accepted"
  ];

  const checkProgress = [
    ...new Set(
      statusProgressReport?.reduce((acc, e) => {
        acc.push(e.semester);
        return acc;
      }, [])
    )
  ];

  const ColorlibStepIcon = (props) => {
    const { className, icon } = props;
    let semester = {};
    let icons = {};

    if (statusProgressReport?.length !== 0 && _.isEmpty(semester))
      semester = formatSemester(statusProgressReport);

    if (checkProgress.some((e) => e === "semester_extension")) {
      if (role === ROLE_PHD_3Y) {
        icons = {
          1: getIcon(semester?.semester1),
          2: getIcon(semester?.semester2),
          3: getIcon(semester?.semester3),
          4: getIcon(semester?.semester4),
          5: getIcon(semester?.semester5),
          6: getIcon(semester?.semester6),
          7: <CloseIcon />,
          8: getIcon(semester?.semester_extension),
          9: getIcon(semester?.semester_extension)
        };
      } else {
        icons = {
          1: getIcon(semester?.semester1),
          2: getIcon(semester?.semester2),
          3: getIcon(semester?.semester3),
          4: getIcon(semester?.semester4),
          5: getIcon(semester?.semester5),
          6: getIcon(semester?.semester6),
          7: getIcon(semester?.semester7),
          8: getIcon(semester?.semester8),
          9: getIcon(semester?.semester9),
          10: getIcon(semester?.semester10),
          11: <CloseIcon />,
          12: getIcon(semester?.semester_extension),
          13: getIcon(semester?.semester_extension)
        };
      }
    } else {
      if (role === ROLE_PHD_3Y) {
        icons = {
          1: getIcon(semester?.semester1),
          2: getIcon(semester?.semester2),
          3: getIcon(semester?.semester3),
          4: getIcon(semester?.semester4),
          5: getIcon(semester?.semester5),
          6: getIcon(semester?.semester6)
        };
      } else {
        icons = {
          1: getIcon(semester?.semester1),
          2: getIcon(semester?.semester2),
          3: getIcon(semester?.semester3),
          4: getIcon(semester?.semester4),
          5: getIcon(semester?.semester5),
          6: getIcon(semester?.semester6),
          7: getIcon(semester?.semester7),
          8: getIcon(semester?.semester8),
          9: getIcon(semester?.semester9),
          10: getIcon(semester?.semester10),
          11: getIcon(semester?.semester10)
        };
      }
    }

    return (
      <ColorlibStepIconRoot
        ownerState={{ icon, choose: icons[String(icon)] }}
        className={className}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  };

  return (
    <Card>
      <Box sx={{ p: 3, pb: 1, paddingTop: 5 }} dir="ltr">
        <Stack sx={{ width: "100%" }} spacing={4}>
          <Stepper
            alternativeLabel
            connector={<ColorlibConnector />}
            sx={{ paddingBottom: 3 }}
          >
            {(checkProgress.some((e) => e === "semester_extension")
              ? role === ROLE_PHD_3Y
                ? steps_extension
                : steps_extension5y
              : role === ROLE_PHD_3Y
              ? steps
              : steps5y
            ).map((label, index) => (
              <Step key={index}>
                <StepLabel StepIconComponent={ColorlibStepIcon}>
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Stack>
      </Box>
    </Card>
  );
}
